import React from "react";
import { Link } from "react-router-dom";

interface FeaturePoint {
  text: string;
}

interface Button {
  text: string;
  href: string;
  variant?: "primary" | "line";
  icon?: string;
}

interface FeaturedInitiativeProps {
  tagline: string;
  title: string;
  description: string;
  image: string;
  imageAlt: string;
  features?: FeaturePoint[];
  buttons?: Button[];
}

const FeaturedInitiative: React.FC<FeaturedInitiativeProps> = ({
  tagline,
  title,
  description,
  image,
  imageAlt,
  features = [],
  buttons = [
    {
      text: "Know More",
      href: "/initiatives/utop",
      variant: "line" as const,
    },
  ],
}) => {
  return (
    <div className="featured-initiative">
      <div className="row align-items-center">
        <div className="col-xl-6 col-lg-6 m-0">
          <div className="featured-initiative-left">
            <div className="featured-initiative-title-box">
              <p className="featured-initiative-tagline">{tagline}</p>
              <h3>{title}</h3>
            </div>
            <p className="featured-initiative-text">{description}</p>
            <ul className="featured-initiative-points">
              {features.map((feature, index) => (
                <li key={index}>
                  <div className="icon">
                    <i className="fal fa-check"></i>
                  </div>
                  <div className="text">
                    <p>{feature.text}</p>
                  </div>
                </li>
              ))}
            </ul>
            <div className="featured-initiative-btn-box">
              {buttons.map((button, index) => {
                const isInternal = button.href.startsWith("/");
                const className = `btn-main ${
                  button.variant === "line" ? "btn-line ms-2" : "mr-2"
                }`;
                return isInternal ? (
                  <Link
                    key={index}
                    to={button.href}
                    className={className}
                  >
                    {button.text}
                    {button.icon && <i className={button.icon}></i>}
                  </Link>
                ) : (
                  <a
                    key={index}
                    href={button.href}
                    className={className}
                  >
                    {button.text}
                    {button.icon && <i className={button.icon}></i>}
                  </a>
                );
              })}
            </div>
          </div>
        </div>
        <div className="col-xl-6 col-lg-6">
          <div className="featured-initiative-right">
            <div className="featured-initiative-img-box">
              <div className="featured-initiative-img">
                <img src={image} alt={imageAlt} />
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};

export default FeaturedInitiative;
